import { render, staticRenderFns } from "./RetailerDetail.vue?vue&type=template&id=4a5a4c48&scoped=true"
import script from "./RetailerDetail.vue?vue&type=script&lang=js"
export * from "./RetailerDetail.vue?vue&type=script&lang=js"
import style0 from "./RetailerDetail.vue?vue&type=style&index=0&id=4a5a4c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a4c48",
  null
  
)

export default component.exports